module.exports = __webpack_public_path__ + "img/Crooked Stone.4154ba2c.png";